import React from "react";
import ChessPiece from "./ChessPiece";
import { coord } from "./chessEngine";

function orientedRange(orientation) {
  const rows =
    orientation === "w"
      ? [0, 1, 2, 3, 4, 5, 6, 7]
      : [7, 6, 5, 4, 3, 2, 1, 0];

  const cols =
    orientation === "w"
      ? [0, 1, 2, 3, 4, 5, 6, 7]
      : [7, 6, 5, 4, 3, 2, 1, 0];

  return { rows, cols };
}

export default function ChessBoard({
  board,
  selected,
  legalMoves,
  lastMove,
  inCheck,
  turn,
  boardTheme,
  pieceSet,
  orientation,
  showCoordinates,
  disabled,
  onSquareClick,
}) {
  const { rows, cols } =
    orientedRange(orientation);

  return (
    <div
      className="chess-board-wrap"
      data-board-theme={boardTheme}
      data-piece-set={pieceSet}
    >
      <div
        className="hobbli-chess-board"
        role="grid"
        aria-label="Chess board"
      >
        {rows.map((r, displayRow) =>
          cols.map((c, displayCol) => {
            const piece = board[r][c];

            const isSelected =
              selected?.r === r &&
              selected?.c === c;

            const legalMove =
              legalMoves.find(
                (move) =>
                  move.r === r &&
                  move.c === c
              );

            const isLastMove =
              lastMove &&
              (
                (
                  lastMove.from.r === r &&
                  lastMove.from.c === c
                ) ||
                (
                  lastMove.to.r === r &&
                  lastMove.to.c === c
                )
              );

            const kingInCheck =
              inCheck &&
              piece === `${turn}K`;

            const squareName =
              coord(r, c);

            const rankLabel =
              showCoordinates &&
              displayCol === 0
                ? squareName[1]
                : null;

            const fileLabel =
              showCoordinates &&
              displayRow === 7
                ? squareName[0]
                : null;

            return (
              <button
                key={`${r}-${c}`}
                type="button"
                role="gridcell"
                aria-label={`${squareName} ${
                  piece || "empty"
                }`}
                className={[
                  "chess-square",
                  (r + c) % 2 === 0
                    ? "is-light"
                    : "is-dark",
                  isSelected
                    ? "is-selected"
                    : "",
                  legalMove
                    ? "is-legal"
                    : "",
                  legalMove?.capture
                    ? "is-capture"
                    : "",
                  isLastMove
                    ? "is-last-move"
                    : "",
                  kingInCheck
                    ? "is-check"
                    : "",
                ]
                  .filter(Boolean)
                  .join(" ")}
                onClick={() =>
                  onSquareClick(r, c)
                }
                disabled={disabled}
              >
                {rankLabel && (
                  <span className="chess-square__rank">
                    {rankLabel}
                  </span>
                )}

                {fileLabel && (
                  <span className="chess-square__file">
                    {fileLabel}
                  </span>
                )}

                <ChessPiece
                  piece={piece}
                  pieceSet={pieceSet}
                />
              </button>
            );
          })
        )}
      </div>
    </div>
  );
}
